import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Help from '../../Common/Help/Help';
import editIcon from '../../../images/icons/edit.svg';
import deleteIcon from '../../../images/icons/delete.svg';
import AlertModal from '../../Common/AlertModal/AlertModal';
import './Questions.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Questions extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            questions: [],
            form: {
                id: '',
                active: true,
                required: false,
                question_name: '',
            },
            validation: {
                alreadyExists: false
            },
            editMode: false,
            isModalOpen: false,
            targetQuestionId: null,
            message: {
                title: '',
                content: '',
                type: ''
            }
         }
    }

    toggleAlertModal = (e) => {
        const targetQuestionId = e.target.id;
        this.setState({
            isModalOpen: !this.state.isModalOpen,
            targetQuestionId
        });
    }

    confirmAlertModal = () => {
        this.removeQuestion(this.state.targetQuestionId);
        this.setState({
            isModalOpen: false,
            targetQuestionId: null
        });
    }
  
    handleChange = (e) => {
        let value = e.target.value;
        const type = e.target.type;
        const form = { ...this.state.form };
        if (type === "checkbox") {
            value = e.target.checked;
            const name = e.target.name;
            if (name === 'required') {
                (value === false) ? value = false : value = true;
            } else {
                (value === false) ? value = true : value = false;
            }
            form[name] = value;
        } else {
            form['question_name'] = value;
        }
        this.setState({ form });
    }

    getQuestions = () => {
        (async () => {
            try {
                const response = await getClientQuestions();
                if (response.data.error) {
                    this.props.setMessage(window.general_strings.msg.oops, response.data.error.code, 'error');
                } else {
                    console.log('Client Questions: ', response);
                    if (response.data.questions) {
                        this.setState({ questions: response.data.questions });
                    }
                }
            } catch (error) {
                this.props.setMessage(window.general_strings.msg.oops, error, 'error');
            }
        })()

        async function getClientQuestions() {
            return await ApiRequest(`/client-questions`);
        }
    }

    updateQuestion = () => {
        this.props.setMessage('', '', 'loading');
        const targetQuestionId = this.state.editMode ? this.state.targetQuestionId : '';
        const method = this.state.editMode ? 'put' : 'post';

        (async () => {
            try {
                let response = await addQuestion(this.state.form, targetQuestionId, method);
                if (response.data.error) {
                    this.props.setMessage(window.general_strings.msg.oops, response.data.error.code, 'error');
                    window.scrollTo(0, 0);
                } else {
                    console.log('Add question Response: ', response);
                    this.props.setMessage('', '', '');
                    this.getQuestions();
                }
            } catch (error) {
                this.props.setMessage(window.general_strings.msg.oops, error, 'error');
                window.scrollTo(0, 0);
            }
        })()

        async function addQuestion(data, targetQuestionId, method) {
            return await ApiRequest(`/client-questions/${targetQuestionId}`, {
                method,
                data: {
                    question: data.question_name,
                    status: data.active ? 'active' : 'inactive',
                    required: data.required,
                }
            });
        }
        this.resetInputs();
    }

    editQuestion = (e) => {
        const id = parseInt(e.target.id, 0);
        const questions = [...this.state.questions];
        const question = questions.filter(question => question.id === id);
        const form = { ...this.state.form };
        form['id'] = question[0].id;
        form['active'] = question[0].status === 'active';
        form['required'] = question[0].required;
        form['question_name'] = question[0].question;
        questions.forEach((question, i) => {
            if (question.id === parseInt(id, 0)) {
                //questions.splice(i, 1);
            }
        })
        this.setState({ 
            form,
            //questions, 
            editMode: true,
            targetQuestionId: id
        });
    }

    removeQuestion = (id) => {
        const questions = [...this.state.questions];
        questions.forEach((question, i) => {
            if (question.id === parseInt(id, 0)) {
                questions.splice(i, 1);
            }
        })
        this.setState({ questions }, async () => {
            try {
                const response = await deleteQuestion();
                console.log('Delete question: ', response);
            } catch (error) {
                console.log(error);
            }

            async function deleteQuestion() {
                return await ApiRequest(`/client-questions/${id}`, {
                    method: 'delete'
                });
            }
        })
    }

    resetInputs = () => {
        const form = {...this.state.form};
        document.getElementById('question-inactive').checked = false;
        document.getElementById('question-required').checked = false;
        form['id'] = '';
        form['active'] = true;
        form['required'] = false;
        form['question_name'] = '';
        this.setState({ 
            form, 
            targetQuestionId: null,
            editMode: false
        });
    }

    validate = () => {
        const question_name = this.state.form.question_name;
        const questions = [...this.state.questions];
        const validation = { ...this.state.validation }
        if (questions.some((question) => question.question === question_name)) {
            validation['alreadyExists'] = true;
        } else {
            validation['alreadyExists'] = false;
        }
        this.setState({ validation });
    }

    componentDidMount() {
        this.getQuestions();
    }

    render() { 
        return ( 
            <React.Fragment>
                <AlertModal
                    isModalOpen={this.state.isModalOpen}
                    toggleAlertModal={this.toggleAlertModal}
                    confirmAlertModal={this.confirmAlertModal}
                    modalTitle={strings.modalTitle}
                    modalDescription={strings.modalDescription}
                />
                <div className="showtix-section showtix-background__primary-5">
                    <div className="container">
                        <h1>{strings.title}</h1>

                        <div className="row">
                            { strings.helps &&
                            <div className="col-12 col-lg-4">
                                {strings.helps.map((help, i) =>
                                    <Help help={help} key={i} />
                                )}
                            </div>
                            }
                            <div className="col-12 col-lg-8">
                                <div className="row">
                                    <div className="col-12 text-left">
                                        <div className="showtix-form__group">
                                            <div className="showtix-form__checkbox">
                                                <input
                                                    id="question-inactive"
                                                    className="showtix-input"
                                                    type="checkbox"
                                                    name="active"
                                                    onChange={this.handleChange}
                                                    checked={!this.state.form.active}
                                                />
                                                <label className="showtix-label" htmlFor="question-inactive">{strings.activeLabel}</label>
                                            </div>
                                        </div>
                                        <div className="showtix-form__group">
                                            <div className="showtix-form__checkbox">
                                                <input
                                                    id="question-required"
                                                    className="showtix-input"
                                                    type="checkbox"
                                                    name="required"
                                                    onChange={this.handleChange}
                                                    checked={this.state.form.required}
                                                />
                                                <label className="showtix-label" htmlFor="question-required">{strings.requiredLabel}</label>
                                            </div>
                                        </div>
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="question-name">{strings.add}</label>
                                            <div className="showtix-form__input">
                                                <textarea
                                                    id="question-name"
                                                    className="showtix-input"
                                                    type="text"
                                                    onChange={this.handleChange}
                                                    rows="2"
                                                    value={this.state.form.question_name}
                                                >
                                                    {this.state.form.question_name}
                                                </textarea>
                                            </div>
                                            {
                                            this.state.validation.alreadyExists &&
                                                <div className="showtix-note error">
                                                    {strings.questionAlreadyExists}
                                                </div>
                                            }
                                        </div>
                                        <div className="showtix-form__group">
                                            <button
                                                type="button"
                                                className="showtix-button showtix-background__primary-1"
                                                onClick={this.updateQuestion}
                                                disabled={this.state.form.question_name === '' || this.state.validation.alreadyExists ? true : false}
                                            >
                                                <span>{this.state.editMode ? strings.editButton : strings.addButton}</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-12 text-left">
                                        <div className="table-responsive">
                                            { this.state.questions.length ?
                                                <table className="showtix-table showtix-table__striped showtix-table__fixed-height">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: 50 }}></th>
                                                            <th>Question</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.questions.map((question, i) => {
                                                                return (
                                                                    <tr key={i}>
                                                                        <td className="text-left" style={{ width: 50 }}>
                                                                            <img
                                                                                id={question.id}
                                                                                className="edit-icon"
                                                                                src={editIcon}
                                                                                alt="edit icon"
                                                                                onClick={this.editQuestion}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            {question.question}
                                                                            {question.status === 'inactive' && <span className="showtix-badge warning">Inactive</span>}
                                                                            {question.required && <span className="showtix-badge required">Required</span>}
                                                                        </td>
                                                                        <td className="text-right">
                                                                            <img
                                                                                id={question.id}
                                                                                className="delete-icon"
                                                                                src={deleteIcon}
                                                                                alt="delete icon"
                                                                                onClick={(e) => this.toggleAlertModal(e)}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            : 
                                                <p>No questions yet.</p>
                                            }
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </React.Fragment>
         )
    }
}

export default Questions;


// WEBPACK FOOTER //
// ./src/components/ClientPreferences/Questions/Questions.js